import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import { color, space } from 'styled-system';

const StyledLink = styled(NavLink)`
  color: ${props => props.theme.colors.copy} !important;
  padding-left: 12px;
  padding-right: 12px;
  margin-right: 16px;
  ${space}
  ${color}
`;

function StyledNavLink({ to, text, children, activeBg, ...rest }: any) {
  return (
    <StyledLink
      exact
      activeClassName="selected"
      activeStyle={{
        color: activeBg,
      }}
      to={to}
      {...rest}
    >
      {text || children}
    </StyledLink>
  );
}

export default StyledNavLink;
